import { createFileRoute } from "@tanstack/react-router";
import PDFToSheetGuideFr from "@/pages/resources/fr/PDFToSheetGuideFr";

export const Route = createFileRoute("/fr/learn/pdf-to-sheet")({
  head: () => ({
    meta: [
        {
            "title": "Transformer un PDF de cours en fiche : le tutoriel | System Atlas"
        },
        {
            "name": "description",
            "content": "Tutoriel étape par étape pour transformer vos PDFs de cours en fiches de révision structurées avec l'IA. Upload, génération, affinage et étude efficace."
        },
        {
            "property": "og:title",
            "content": "Transformer un PDF de cours en fiche : le tutoriel | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Tutoriel étape par étape pour transformer vos PDFs de cours en fiches de révision structurées avec l'IA. Upload, génération, affinage et étude efficace."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/pdf-to-sheet"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Transformer un PDF de cours en fiche : le tutoriel | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Tutoriel étape par étape pour transformer vos PDFs de cours en fiches de révision structurées avec l'IA. Upload, génération, affinage et étude efficace."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/pdf-to-sheet"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/pdf-to-sheet"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/pdf-to-sheet"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/pdf-to-sheet"
        }
    ],
  }),
  component: PDFToSheetGuideFr,
});
